module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_7042.d1e5915e.png";